export const ENGLISH_PUZZLE_START_SCREEN = 'ENGLISH_PUZZLE_START_SCREEN';
export const ENGLISH_PUZZLE_GAME_SCREEN = 'ENGLISH_PUZZLE_GAME_SCREEN';

export const SHOW_TRUE = 'SHOW_TRUE';
export const MAX_WORDS_FOR_GAME = 10;

export const LEARNED_WORDS = 'LEARNED_WORDS';
export const SELECTED_WORDS = 'SELECTED_WORDS';
